import { all, call, delay, put, select, takeLatest } from 'redux-saga/effects';
import { uploadFilesSaga } from '../upload/saga';
import {
    assignRedeemableCodeFail,
    assignRedeemableCodeSuccess,
    awardPrizeFail,
    awardPrizeSuccess,
    castVoteFail,
    castVoteSuccess,
    createAwardCategoryFail,
    createAwardCategorySuccess,
    createBookmarkFail,
    createBookmarkSuccess,
    createContestFail,
    createContestSuccess,
    createHostFail,
    createHostSuccess,
    createPartnerFail,
    createPartnerSuccess,
    createScoreCategoryFail,
    createScoreCategorySuccess,
    deleteBookmarkFail,
    deleteBookmarkSuccess,
    deleteContestFail,
    deleteContestSuccess,
    deleteHostFail,
    deleteHostSuccess,
    deletePartnerFail,
    deletePartnerSuccess,
    downloadAssetFail,
    downloadAssetSuccess,
    getAllPartnersFail,
    getAllPartnersSuccess,
    getAllSubmissionFail,
    getAllSubmissionSuccess,
    getAwardCategoriesForContestFail,
    getAwardCategoriesForContestSuccess,
    getBookmarkFail,
    getBookmarkSuccess,
    getContestAwardsFail,
    getContestAwardsSuccess,
    getContestFail,
    getContestReferencesFail,
    getContestReferencesSuccess,
    getContestSuccess,
    getContestsFail,
    getContestsSuccess,
    getHostFail,
    getHostSuccess,
    getMySubmissionsFail,
    getMySubmissionsSuccess,
    getPartnerFail,
    getPartnerSuccess,
    getRecommendationFail,
    getRecommendationSuccess,
    getRedeemableCodesFail,
    getRedeemableCodesSuccess,
    getS3imagesFail,
    getS3imagesSuccess,
    getUserContestFail,
    getUserContestSuccess,
    getUserContestsSuccess,
    getUserContestsFail,
    getUsersUnsubmittedProjectsFail,
    getUsersUnsubmittedProjectsSuccess,
    initaiet2FAForVoteFail,
    initaiet2FAForVoteSuccess,
    publishContestFail,
    publishContestSuccess,
    rescindSubmissionFail,
    rescindSubmissionSuccess,
    updateSubmissionFail,
    updateSubmissionSuccess,
    searchHostFail,
    searchHostSuccess,
    searchPartnerFail,
    searchPartnerSuccess,
    sendContestEmailFail,
    sendContestEmailSucess,
    sendWinnersEmailFail,
    sendWinnersEmailSucess,
    setCategoryForSubmission,
    setVoting2Fa,
    setVotingFlow,
    submitProjectFail,
    submitProjectSuccess,
    unPublishContestFail,
    unPublishContestSuccess,
    updateContest as updateContestAction,
    updateContestFail,
    updateContestSuccess,
    updateHostFail,
    updateHostSuccess,
    updatePartnerFail,
    updatePartnerSuccess,
    updatePartner as updatePartnerAction,
    updateHost as updateHostAction,
    deleteAwardCategorySuccess,
    deleteAwardCategoryFail,
    getContestSubmissionsSuccess,
    getContestSubmissionsFail,
    getContestManageSuccess,
    getContestManageFail,
    updateCampaignAwardsSuccess,
    updateCampaignAwardsFail,
    updateAwardCategorySuccess,
    updateAwardCategoryFail,
    verifyProjectSuccess,
    verifyProjectFail,
    // Video Management Actions
    getPreselectionSubmissionsFail,
    getPreselectionSubmissionsSuccess,
    preselectSubmissionsSuccess,
    preselectSubmissionsFail,
    sendSelectionEmailFail,
    sendSelectionEmailSuccess,
} from './actions';
import { globalErrorHandler } from '../error/saga';
import { api } from '../../configurations/api';
import {
    assignRedeemableCodeUrl,
    awardsCategoryUrl,
    awardsUrl,
    downloadContestAssetUrl,
    getContestMetricsUrl,
    getContestUrl,
    getContestWithContestIdUrl,
    getMySubmissionsUrl,
    getRecommendationUrl,
    getRedeemableCodesUrl,
    getSavedCollectionUrl,
    hostUrl,
    partnerUrl,
    publishContestUrl,
    saveCollectionUrl,
    scoreCategoryUrl,
    submissionsUrl,
    unPublishContesturl,
    winnersEmailUrl,
} from '../../configurations/api/url';
import { httpRequest } from '../types';
import {
    IContest,
    IGenericDocumentModifier,
    IGetAllResponse,
    IReedemableCode,
    ISubmission,
} from '../../types/global/helper';
import {
    ISubmitProject,
    types,
    IGetContestPayload,
    IGetContests,
    IInitiate2FaForVote,
    ICastVote,
    ICreateBookmark,
    ICreateContestPayload,
    IGetUserContest,
    IGetUserContests,
    ICreateHost,
    IGetHost,
    IGetAllHosts,
    ICreatePartner,
    IGetPartner,
    IGetAllPartners,
    ISearchPayload,
    ISearchHostResponse,
    ISearchPartnerResponse,
    ICreateAwardCategory,
    IAssignRedeemableCode,
    IGetRedeemableCodes,
    IAwardPrize,
    ICreateWinnersEmail,
    IGetAllSubmissions,
    ICreateScoreCategory,
    IGetUnsubmittedProjects,
    IContestInitialState,
    ISendContestEmail,
    IGetS3ImagesResponse,
    IGetSubmissions,
    IBookmark,
    IGetSavedCollections,
    IGetContestSubmissions,
    IGetManageCampiagn,
    IUpdateCampaignAwards,
    IGetPreselectionSubmissions,
    ISendSelectionEmail,
    IPreselectSubmissions,
    IUpdateSubmission,
} from './types';
import { CACHE_TYPE, CacheValue, NotUniqueCacheValue } from '../cache/types';
import { getCacheByType, getCacheDuration, getNotUniqueCacheByKey, isUseCacheEnabled } from '../cache/saga';
import { destroyOneCache, setCache } from '../cache/action';
import { showToastMessage } from '../../utils/AppUtils';
import { IErrorType } from '../../constants/types';
import { setInAppNotification } from '../in-app-notification/actions';
import { SentryCapture } from '../../analytics/Sentry';
import { Action } from 'redux';
import { isEmpty } from '../../utils/lodash';
import { navigate } from '../navigator/action';
import { ROUTES } from '../../types/global/routes.types';
import { replaceRouteParam } from '../../utils/routesProcessor';
import { refreshUserDashboard } from '../account/actions';
import { getProject } from '../project/saga';
import { RootState } from '../root-reducer';

function* verifyProject({ payload, resolve, reject }: { payload: ISubmitProject; resolve: any; reject: any }): any {
    try {
        const response = yield call(api, `${submissionsUrl}/validate`, httpRequest.POST, payload);
        const { message, reason } = response;
        yield put(verifyProjectSuccess({ message, reason }));
        if (resolve) resolve({ message, reason });
    } catch (error: any) {
        yield put(verifyProjectFail(error));
        if (reject) reject(error);
    }
}

/** The below will aid the host in self submitting.
 * The idea is to have them upload their own projects
 * then submit it. This below will return only the projects that have not been submitted
 */
function* getUnsubmittedProjects({ payload }: { payload: IGetUnsubmittedProjects }): Generator<any, any, any> {
    const defaultUseCache = yield* isUseCacheEnabled();
    const { contestId, sortBy, limit, page, searchTerm } = payload;
    const params = new URLSearchParams();

    if (limit) {
        params.append('limit', limit.toString());
    }

    if (sortBy) {
        params.append('sort', sortBy);
    }

    if (page) {
        params.append('page', page.toString());
    }

    if (searchTerm) {
        params.append('searchTerm', searchTerm);
    }

    const queryString = params.toString();

    const appended = queryString ? `?${queryString}` : '';

    let initialResult: any = null;
    const localCacheKey = `${queryString}-${contestId}`;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.UNSUBMITTED_PROJECTS, localCacheKey);
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (defaultUseCache && initialResult) {
        yield put(
            getUsersUnsubmittedProjectsSuccess({
                ...initialResult,
                details: payload,
            }),
        );
    } else {
        try {
            const request = `${getContestUrl}/${contestId}/unsubmitted${appended}`;
            const response = yield call(api, request, httpRequest.GET, null, 2);
            const { data } = response;
            yield put(
                getUsersUnsubmittedProjectsSuccess({
                    ...data,
                    details: payload,
                }),
            );
            yield put(
                setCache({
                    key: localCacheKey,
                    value: data,
                    type: CACHE_TYPE.UNSUBMITTED_PROJECTS,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            yield put(getUsersUnsubmittedProjectsFail(error));
        }
    }
}

function* getContestReferences({ payload }: { payload: string[] }): any {
    try {
        const projectCalls = payload.map(id =>
            getProject({ payload: { id, skipAuthentication: true, withNavigate: false, skipMediaSet: true } }),
        );
        const projects = yield all(projectCalls);
        yield put(getContestReferencesSuccess(projects));
    } catch (error: any) {
        yield put(getContestReferencesFail(error));
    }
}

function* createScoreCategory({ payload }: { payload: ICreateScoreCategory }): Generator<any, any, any> {
    try {
        const response = yield call(api, scoreCategoryUrl, httpRequest.POST, payload);
        const { data } = response.data;
        yield put(createScoreCategorySuccess(data));
    } catch (error: any) {
        yield put(createScoreCategoryFail(error));
    }
}

function* getContestScoreBoard({ payload }: { payload: IGetAllSubmissions }): Generator<any, any, any> {
    const { contestId, sortBy, limit, page, refresh } = payload;
    let params = '';
    if (sortBy) {
        params += `?sortby=${sortBy}`;
    }
    if (limit) {
        params += `&limit=${limit}`;
    }

    if (page) {
        params += `&page=${page}`;
    }

    if (refresh) {
        const now = new Date().toISOString();
        params += `&refresh=${refresh}&date=${now}`;
    }
    const request = `${getContestUrl}/${contestId}/score${params}`;
    try {
        const response = yield call(api, request, httpRequest.GET, {}, 2, 1000);
        const { data } = response;
        yield put(
            getAllSubmissionSuccess({
                submissions: data,
                details: payload,
            }),
        );
    } catch (error: any) {
        yield put(getAllSubmissionFail(error));
    }
}

function* sendConclusionEmail({ payload }: { payload: ICreateWinnersEmail }): Generator<any, any, any> {
    try {
        yield call(api, winnersEmailUrl, httpRequest.POST, payload);
        yield put(sendWinnersEmailSucess());
        yield* updateContest({
            payload: {
                documentId: payload.contestId,
                payload: {
                    winner_email_sent: !payload.is_test,
                },
            },
        });
        yield delay(1000);
        /** Fetch the contest again to update the new values */
        yield* getUserContest({
            payload: {
                contestId: payload.contestId,
                skipRefresh: true,
                withNavigate: false,
            },
        });
    } catch (error: any) {
        yield put(sendWinnersEmailFail(error));
    }
}

function* getS3ImagesSaga({ payload }: { payload: IGetS3ImagesResponse }): Generator<any, any, any> {
    try {
        const response = yield call(api, `${getContestUrl}/s3-images`, httpRequest.GET, payload);
        const data = response.data.images;
        yield put(getS3imagesSuccess(data));
    } catch (error: any) {
        yield put(getS3imagesFail(error));
    }
}

function* sendContestEmailSaga({ payload }: { payload: ISendContestEmail }): Generator<any, any, any> {
    let apiUrl = '';
    let successMessage = '';
    if (payload.type && payload.type.length > 0) {
        const emailType = payload.type[0];
        try {
            if (emailType === 'contest submission notification email') {
                apiUrl = `${getContestUrl}/${payload.contestId}/submission-reminder-email`;
                successMessage = 'Contest submission notification email sent';
            } else if (emailType === 'voting reminder email') {
                apiUrl = `${getContestUrl}/vote-reminder`;
                successMessage = 'Voting reminder email sent';
            } else if (emailType === 'contest notification email') {
                apiUrl = `${getContestUrl}/${payload.contestId}/notify`;
                successMessage = 'Contest notification email sent';
            } else if (emailType === 'send contest open email') {
                apiUrl = `${getContestUrl}/${payload.contestId}/submission-open-email`;
                successMessage = 'Contest open email sent';
            }
            yield call(api, apiUrl, httpRequest.POST, {
                contestId: payload.contestId,
                subject: payload.subject,
                image: payload.image,
                message: payload.message,
                testUsers: payload.testUsers,
            });

            yield put(sendContestEmailSucess());
            yield delay(1000);

            yield call(showToastMessage, successMessage, 'success');

            yield* getUserContest({
                payload: {
                    contestId: payload.contestId,
                    skipRefresh: true,
                    withNavigate: false,
                },
            });
        } catch (error: any) {
            yield put(sendContestEmailFail(error));
        }
    }
}

function* downloadAsset({ payload, resolve, reject }: any): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${downloadContestAssetUrl}`,
            httpRequest.POST,
            payload,
            0,
            1000,
            false,
            undefined,
            undefined,
            undefined,
            'blob',
        );
        yield put(downloadAssetSuccess(response));
        resolve(response);
    } catch (error: any) {
        SentryCapture(error, 'error');
        reject(error);
        yield put(downloadAssetFail(error));
    }
}
function* getAssignedCodes({ payload }: { payload: IGetRedeemableCodes }): Generator<any, any, any> {
    const defaultUseCache = yield* isUseCacheEnabled();
    const { contestId, limit = 100, page = 0 } = payload;
    let initialResult: any = null;
    const request = `${getRedeemableCodesUrl}?contest=${contestId}&page=${page}&limit=${limit}`;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.REDEEMABLE_CODE, contestId);
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (defaultUseCache && initialResult) {
        yield put(getRedeemableCodesSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, request, httpRequest.GET, null, 2, 1000);
            const { data } = response.data;
            yield put(getRedeemableCodesSuccess(data));
            yield put(
                setCache({
                    key: contestId,
                    value: data,
                    type: CACHE_TYPE.REDEEMABLE_CODE,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            yield put(getRedeemableCodesFail(error));
        }
    }
}

function* assignCodes({
    payload,
    resolve,
    reject,
}: {
    payload: IAssignRedeemableCode;
    resolve: any;
    reject: any;
}): Generator<any, any, any> {
    const { contestId, userId } = payload;
    /** Create code First
     *
     */
    try {
        const response = yield call(api, getRedeemableCodesUrl, httpRequest.POST, { contest: contestId }, 0, 1000);
        const { data }: { data: IReedemableCode } = response;
        if (data) {
            /** Send to user */
            const userResponse = yield call(api, assignRedeemableCodeUrl, httpRequest.POST, {
                userId,
                redeemCodeId: data._id,
            });
            const redeemcodeObject = userResponse;
            yield put(assignRedeemableCodeSuccess(redeemcodeObject.data));
            yield put(
                destroyOneCache({
                    cacheType: CACHE_TYPE.REDEEMABLE_CODE,
                }),
            );
        }
        yield call(showToastMessage, 'Code sent successfully', 'success');
        resolve(response);
    } catch (error: any) {
        yield call(globalErrorHandler, error);
        yield put(assignRedeemableCodeFail(error));
        reject(error);
    }
}

function* createAwardCategory({ payload }: { payload: ICreateAwardCategory }): any {
    try {
        const response = yield call(api, awardsCategoryUrl, httpRequest.POST, payload, 0, 0);
        const { data } = response.data;
        yield put(createAwardCategorySuccess(data));
        if (payload.category) {
            yield* updateCampaignAwardCategories({
                payload: {
                    action: 'add',
                    awardCategoryId: data._id,
                    categoryId: payload.category,
                    contestId: payload.contest,
                },
            });
        }
        return data;
    } catch (error: any) {
        yield call(globalErrorHandler, error);
        SentryCapture(error, 'error');
        yield put(createAwardCategoryFail(error));
    }
}

function* updateAwardCategory({ payload }: { payload: IGenericDocumentModifier }): any {
    try {
        const response = yield call(
            api,
            `${awardsCategoryUrl}/${payload.documentId}`,
            httpRequest.PATCH,
            payload.payload,
            0,
            0,
        );
        const { data } = response.data;
        if (payload.payload.category) {
            yield* updateCampaignAwardCategories({
                payload: {
                    action: 'add',
                    awardCategoryId: data._id,
                    categoryId: payload.payload.category,
                    contestId: data.contest,
                },
            });
        }
        yield put(updateAwardCategorySuccess({ body: data, payload: payload.payload }));
        return data;
    } catch (error: any) {
        yield call(globalErrorHandler, error);
        SentryCapture(error, 'error');
        yield put(updateAwardCategoryFail(error));
    }
}

function* deleteAwardCategory({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        yield call(api, `${awardsCategoryUrl}/${payload.documentId}`, httpRequest.DELETE, payload, 0, 0);
        yield put(deleteAwardCategorySuccess(payload));
        if (payload?.payload?.categoryId && payload?.payload?.contestId)
            yield* updateCampaignAwardCategories({
                payload: {
                    action: 'remove',
                    awardCategoryId: payload.documentId,
                    categoryId: payload.payload.categoryId,
                    contestId: payload.payload.contestId,
                },
            });
    } catch (error: any) {
        yield call(globalErrorHandler, error);
        SentryCapture(error, 'error');
        yield put(deleteAwardCategoryFail(error));
    }
}

function* getAwardCategories({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${awardsCategoryUrl}?contest=${payload.documentId}`,
            httpRequest.GET,
            {},
            0,
            0,
        );
        const { data } = response.data;
        yield put(getAwardCategoriesForContestSuccess(data));
    } catch (error: any) {
        yield put(getAwardCategoriesForContestFail(error));
    }
}

function* getAwardPrizes({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        const response = yield call(api, `${awardsUrl}?contest=${payload.documentId}`, httpRequest.GET, {}, 0, 0);
        const { data } = response.data;
        yield put(getContestAwardsSuccess(data));
    } catch (error: any) {
        yield put(getContestAwardsFail(error));
    }
}

function* awardOnePrize(award: IAwardPrize): Generator<any, any, any> {
    try {
        const response = yield call(api, `${awardsUrl}`, httpRequest.POST, award, 0, 0);
        yield delay(1000);
        const { data } = response;
        yield put(awardPrizeSuccess(data));
        yield call(showToastMessage, 'Prize awarded successfully', 'success');
    } catch (error: any) {
        yield put(awardPrizeFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* awardMultiplePrizez({ payload }: { payload: IAwardPrize[] }): Generator<any, any, any> {
    try {
        yield all(payload.map(award => awardOnePrize(award)));
    } catch (error: any) {
        yield put(awardPrizeFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* searchHost({ payload }: { payload: ISearchPayload }): any {
    const defaultUseCache = yield* isUseCacheEnabled();
    const { searchTerm } = payload;
    let initialResult: any = null;

    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.HOST_SEARCH, searchTerm);
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (initialResult && defaultUseCache) {
        yield put(searchHostSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${hostUrl}/search`, httpRequest.POST, payload, 2);
            const { data }: { data: ISearchHostResponse } = response;
            yield put(searchHostSuccess(data.result));
            yield put(
                setCache({
                    key: searchTerm,
                    value: data.result,
                    type: CACHE_TYPE.HOST_SEARCH,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(searchHostFail(error));
        }
    }
}

function* searchPartner({ payload }: { payload: ISearchPayload }): any {
    const defaultUseCache = yield* isUseCacheEnabled();
    const { searchTerm } = payload;
    let initialResult: any = null;

    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.PARTNER_SEARCH, searchTerm);
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (initialResult && defaultUseCache) {
        yield put(searchPartnerSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${partnerUrl}/search`, httpRequest.POST, payload, 2);
            const { data }: { data: ISearchPartnerResponse } = response;
            yield put(searchPartnerSuccess(data.result));
            yield put(
                setCache({
                    key: searchTerm,
                    value: data.result,
                    type: CACHE_TYPE.PARTNER_SEARCH,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(searchPartnerFail(error));
        }
    }
}

type Phase = {
    date_started: string;
    expiration_date: string;
    phase: string;
    timezone: string;
};

function getDateRange(phases: Phase[]): { earliestStart: Date; latestEnd: Date } {
    // Sort by date_started
    const sorted = [...phases].sort((a, b) => new Date(a.date_started).getTime() - new Date(b.date_started).getTime());

    const earliestStart = new Date(sorted[0].date_started);

    const latestEnd = new Date(
        phases.reduce((latest, curr) =>
            new Date(curr.expiration_date) > new Date(latest.expiration_date) ? curr : latest,
        ).expiration_date,
    );

    return { earliestStart, latestEnd };
}

interface IPrasedCntestPayload {
    feature_image?: any;
    categories?: any;
    mobile_feature_image?: any;
    contest_media?: any;
    body: Record<string, any>;
}
const parseCampaignPayload = (payload: ICreateContestPayload): IPrasedCntestPayload => {
    const final: IPrasedCntestPayload = {
        feature_image: [],
        categories: [],
        mobile_feature_image: null,
        contest_media: null,
        body: {},
    };

    Object.keys(payload).forEach(key => {
        const currentKey = key as keyof ICreateContestPayload;
        switch (key) {
            case 'feature_image':
                final.feature_image = payload[currentKey];
                break;
            case 'mobile_feature_image':
                final.mobile_feature_image = payload[currentKey];
                break;
            case 'categories':
                final.categories = payload[currentKey];
                break;
            case 'contest_media':
                final.contest_media = payload[currentKey];
                break;
            default:
                if (
                    !['submission_state_message', 'mobile_feature_image_preview', 'feature_image_preview'].includes(key)
                ) {
                    if (key === 'contest_phase_dates' && payload[currentKey] && !isEmpty(payload[currentKey])) {
                        const { earliestStart, latestEnd } = getDateRange(payload[currentKey] as Phase[]);
                        final.body['date_start'] = earliestStart;
                        final.body['expiration_date'] = latestEnd;
                    }
                    final.body[currentKey] = payload[currentKey];
                }
                break;
        }
    });

    return final;
};

function* createContest({ payload }: { payload: ICreateContestPayload }): Generator<any, any, any> {
    const { body, categories, contest_media, feature_image, mobile_feature_image } = parseCampaignPayload(payload);

    let featureImageUpload: any[] | undefined;
    let mobileFeatureImageUpload: any[] | undefined;
    let contestMediaUploads: any[] | undefined;

    try {
        // Create the contest first
        const response = yield call(api, getContestUrl, httpRequest.POST, body, 0, 1000);
        const { data } = response.data;

        /** Upload Media (if present) */
        if (feature_image) {
            featureImageUpload = yield call(uploadFilesSaga as any, {
                payload: {
                    collection: 'contest',
                    directory: 'media',
                    path: 'images',
                    files: feature_image,
                    id: data._1d,
                },
            });
        }

        if (mobile_feature_image) {
            mobileFeatureImageUpload = yield call(uploadFilesSaga as any, {
                payload: {
                    collection: 'contest',
                    directory: 'media',
                    path: 'images',
                    files: mobile_feature_image,
                    id: data._id,
                },
            });
        }

        if (contest_media) {
            contestMediaUploads = yield call(uploadFilesSaga as any, {
                payload: {
                    collection: 'contest',
                    directory: 'media',
                    path: 'assets',
                    files: contest_media,
                    id: data._id,
                },
            });
        }

        // Build update body
        const updateBody: any = {};

        if (featureImageUpload?.length) {
            updateBody.feature_image = featureImageUpload[0];
        }

        if (mobileFeatureImageUpload?.length) {
            updateBody.mobile_feature_image = mobileFeatureImageUpload[0];
        }

        if (contestMediaUploads?.length) {
            updateBody.contest_media = contestMediaUploads;
        }

        // Handle categories array properly: process each category separately
        if (Array.isArray(categories) && categories.length) {
            const processedCategories: any[] = [];

            for (const cat of categories) {
                const nextCat = { ...cat };

                // For each category, if it has category_awards, create them and attach only to that category
                if (Array.isArray(cat.category_awards) && cat.category_awards.length) {
                    const createdAwards = yield all(
                        cat.category_awards.map((award: any) =>
                            // Use call(fn, args) form; adjust if your createAwardCategory signature differs
                            call(createAwardCategory, { payload: { ...award, contest: data._id } }),
                        ),
                    );
                    nextCat.category_awards = createdAwards;
                }

                processedCategories.push(nextCat);
            }

            updateBody.categories = processedCategories;
        }

        // Persist updates back to the contest
        yield put(
            updateContestAction({
                documentId: data._id,
                payload: updateBody,
                fromCreate: true,
            }),
        );

        yield put(createContestSuccess(data));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
        // yield call(showToastMessage, 'Contest created successfully.', 'success');
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(createContestFail(error));
    }
}

function* publishContest({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        const response = yield call(api, `${publishContestUrl}/${payload.documentId}`, httpRequest.PATCH, {}, 2, 1000);
        const { data } = response;
        yield put(publishContestSuccess(data));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
        yield call(showToastMessage, 'Contest published successfully.', 'success');
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(publishContestFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* unPublishContest({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${unPublishContesturl}/${payload.documentId}`,
            httpRequest.PATCH,
            {},
            2,
            1000,
        );
        const { data } = response;
        yield put(unPublishContestSuccess(data));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
        yield call(showToastMessage, 'Contest Updated successfully.', 'success');
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(unPublishContestFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* updateCampaignAwardCategories({ payload }: { payload: IUpdateCampaignAwards }): Generator<any, any, any> {
    try {
        const response = yield call(api, `${getContestUrl}/update-award`, httpRequest.POST, payload, 0, 0, false);
        const { data, message } = response;
        yield put(updateCampaignAwardsSuccess(data));
        yield call(showToastMessage, message, 'success');
    } catch (error: any) {
        SentryCapture(error);
        yield put(updateCampaignAwardsFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* updateContest({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    if (payload.fromCreate) {
        try {
            yield call(api, `${getContestUrl}/${payload.documentId}`, httpRequest.PATCH, payload.payload, 0, 0, false);
            yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
            yield put(destroyOneCache({ cacheType: CACHE_TYPE.DISCOVERY }));
            yield call(showToastMessage, 'Campaign Requested successfully.', 'success');
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield call(globalErrorHandler, error);
            yield put(updateContestFail(error));
        }
    } else {
        const { body, categories, contest_media, feature_image, mobile_feature_image } = parseCampaignPayload(
            payload.payload,
        );
        let featureImageUpload;
        let mobileFeatureImageUpload;
        let contestMediaUplaods;
        const updateBody: any = body;

        try {
            /** Updaate the Media */
            if (feature_image) {
                featureImageUpload = yield call(uploadFilesSaga as any, {
                    payload: {
                        collection: 'contest',
                        directory: 'media',
                        path: 'images',
                        files: feature_image,
                        id: payload.documentId,
                    },
                });
            }

            if (mobile_feature_image) {
                mobileFeatureImageUpload = yield call(uploadFilesSaga as any, {
                    payload: {
                        collection: 'contest',
                        directory: 'media',
                        path: 'images',
                        files: mobile_feature_image,
                        id: payload.documentId,
                    },
                });
            }

            if (contest_media) {
                contestMediaUplaods = yield call(uploadFilesSaga as any, {
                    payload: {
                        collection: 'contest',
                        directory: 'media',
                        path: 'assets',
                        files: contest_media,
                        id: payload.documentId,
                    },
                });
            }

            /** Check and fix */
            if (categories && !isEmpty(categories)) {
                const { category_awards } = categories;
                if (category_awards && !isEmpty(category_awards)) {
                    const awardCategories = yield all(
                        category_awards.map((p: any) => !p._id && call(createAwardCategory({ payload: { ...p } }))),
                    );
                    if (awardCategories) {
                        const internalCategory = categories.map((cat: any) => {
                            cat.category_awards = awardCategories;
                            return cat;
                        });
                        updateBody.categories = internalCategory;
                    }
                } else {
                    updateBody.categories = categories;
                }
            }

            if (featureImageUpload) {
                updateBody.feature_image = featureImageUpload[0];
            }

            if (mobileFeatureImageUpload) {
                updateBody.mobile_feature_image = mobileFeatureImageUpload[0];
            }

            if (contestMediaUplaods) {
                updateBody.contest_media = contestMediaUplaods;
            }

            const response = yield call(
                api,
                `${getContestUrl}/${payload.documentId}`,
                httpRequest.PATCH,
                updateBody,
                0,
                0,
                false,
            );
            const { data } = response.data;
            yield put(updateContestSuccess(data));
            yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
            yield put(destroyOneCache({ cacheType: CACHE_TYPE.DISCOVERY }));
            yield call(showToastMessage, 'Campaign Updated successfully.', 'success');
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield call(globalErrorHandler, error);
            yield put(updateContestFail(error));
        }
    }
}

function* getUserContest({ payload }: { payload: IGetUserContest }): Generator<any, any, any> {
    let query = '?';
    if (payload.filter) query += `filter_by=${payload.filter}&`;
    if (payload.start) query += `start_date=${payload.start}&`;
    if (payload.end) query += `end_date=${payload.end}`;
    const key = `${payload.contestId}${query}`;
    const defaultUseCache = yield* isUseCacheEnabled();
    let initialResult: any = null;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.USER_CONTESTS, key);
    const route = replaceRouteParam(ROUTES.ESCONTEST_ENGAGE, 'contestId', payload.contestId);

    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (initialResult && defaultUseCache) {
        yield put(getUserContestSuccess(initialResult));
        if (payload.withNavigate) {
            yield put(
                navigate({
                    routes: route,
                }),
            );
        }
    } else {
        try {
            const response = yield call(api, `${getContestMetricsUrl}${key}`, httpRequest.GET, null, 0, 0);
            const { data } = response;
            yield put(getUserContestSuccess(data));
            if (payload.withNavigate) {
                yield put(
                    navigate({
                        routes: route,
                    }),
                );
            }
            yield put(
                setCache({
                    key,
                    type: CACHE_TYPE.USER_CONTESTS,
                    value: data,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getUserContestFail(error));
        }
    }
}

function* getUserContests({
    payload,
    resolve,
    reject,
}: {
    payload: IGetUserContests;
    resolve: (data: IGetUserContests) => void;
    reject: (error: any) => void;
}): Generator<any, any, any> {
    const queryParams = new URLSearchParams();
    if (payload.limit) queryParams.append('limit', String(payload.limit));
    if (payload.page) queryParams.append('page', String(payload.page));
    const defaultUseCache = yield* isUseCacheEnabled();
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.USER_CONTESTS, 'all');
    let initialResult: any = null;
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (initialResult && defaultUseCache) {
        yield put(getUserContestsSuccess(initialResult));
        if (resolve) {
            resolve(initialResult);
        }
    } else {
        try {
            const response = yield call(
                api,
                `${getContestUrl}/user-contest?${'' + queryParams}&sort=-created_at`,
                httpRequest.GET,
                null,
                2,
                1000,
                false,
            );
            const { data } = response.data;
            yield put(getUserContestsSuccess(data));
            yield put(
                setCache({
                    key: 'all',
                    type: CACHE_TYPE.USER_CONTESTS,
                    value: data,
                    isUnique: false,
                }),
            );
            if (resolve) {
                resolve(response);
            }
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getUserContestsFail(error));
            if (reject) {
                reject(error);
            }
        }
    }
}

function* deleteContest({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        yield call(api, `${getContestUrl}/${payload.documentId}`, httpRequest.DELETE, null, 0, 1000);
        yield put(deleteContestSuccess(payload));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.USER_CONTESTS,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(deleteContestFail(error));
    }
}

function* createHost({ payload }: { payload: ICreateHost }): Generator<any, any, any> {
    try {
        const { profile_picture, ...restPayload } = payload;
        const response = yield call(api, hostUrl, httpRequest.POST, restPayload, 0, 0);
        const { data } = response.data;
        yield put(createHostSuccess(data));

        if (profile_picture) {
            const profilePicture = yield call(uploadFilesSaga as any, {
                payload: {
                    collection: 'host',
                    directory: 'media',
                    path: 'image',
                    files: [profile_picture],
                    id: data._id,
                },
            });
            yield put(updateHostAction({ documentId: data._id, payload: { profile_picture: profilePicture[0] } }));
        }
        yield call(showToastMessage, 'Host created successfully!', 'success');
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.HOST,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(createHostFail(error));
    }
}

function* updateHost({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${hostUrl}/${payload.documentId}`,
            httpRequest.PATCH,
            payload.payload,
            0,
            0,
            false,
        );
        const { data } = response.data;
        yield put(updateHostSuccess(data));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.HOST,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(updateHostFail(error));
    }
}

function* deleteHost({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        yield call(api, `${hostUrl}/${payload.documentId}`, httpRequest.DELETE, null, 0, 0);
        yield put(deleteHostSuccess(payload));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.HOST,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(deleteHostFail(error));
    }
}

function* getHost({ payload }: { payload: IGetHost }): Generator<any, any, any> {
    let initialResult: any = null;
    const defaultUseCache = yield* isUseCacheEnabled();
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.HOST, payload.hostId);

    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (initialResult && defaultUseCache) {
        yield put(getHostSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${hostUrl}/${payload.hostId}`, httpRequest.GET, null, 0, 0);
            const { data } = response.data;
            yield put(getHostSuccess(data));
            yield put(
                setCache({
                    key: payload.hostId,
                    type: CACHE_TYPE.HOST,
                    value: data,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getHostFail(error));
        }
    }
}

function* getAllHost({ payload }: { payload: IGetAllHosts }): Generator<any, any, any> {
    let query = '?';
    if (payload.params) query += payload.params;

    const key = payload.params ?? 'all';
    const defaultUseCache = yield* isUseCacheEnabled();
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.HOST, key);

    let initialResult: any = null;
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (defaultUseCache && initialResult) {
        yield put(getHostSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${hostUrl}${query}`, httpRequest.GET, null, 0, 0);
            const { data } = response.data;
            yield put(getHostSuccess(data));
            yield put(
                setCache({
                    key: payload.params ?? 'all',
                    type: CACHE_TYPE.HOST,
                    value: data,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getHostFail(error));
        }
    }
}

function* createPartner({ payload }: { payload: ICreatePartner }): Generator<any, any, any> {
    try {
        const { profile_picture, ...restPayload } = payload;
        const response = yield call(api, partnerUrl, httpRequest.POST, restPayload, 0, 0);
        const { data } = response.data;
        yield put(createPartnerSuccess(data));
        if (profile_picture) {
            const profilePicture = yield call(uploadFilesSaga as any, {
                payload: {
                    collection: 'partner',
                    directory: 'media',
                    path: 'image',
                    files: [profile_picture],
                    id: data._id,
                },
            });
            yield put(updatePartnerAction({ documentId: data._id, payload: { profile_picture: profilePicture[0] } }));
        }
        yield call(showToastMessage, 'Partner created successfully!', 'success');

        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.PARTNER,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(createPartnerFail(error));
    }
}

function* updatePartner({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${partnerUrl}/${payload.documentId}`,
            httpRequest.PATCH,
            payload.payload,
            0,
            0,
            false,
        );
        const { data } = response.data;
        yield put(updatePartnerSuccess(data));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.PARTNER,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(updatePartnerFail(error));
    }
}

function* delePartner({ payload }: { payload: IGenericDocumentModifier }) {
    try {
        yield call(api, `${partnerUrl}/${payload.documentId}`, httpRequest.DELETE, null, 0, 0);
        yield put(deletePartnerSuccess(payload));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.PARTNER,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(deletePartnerFail(error));
    }
}

function* getPartner({ payload }: { payload: IGetPartner }): Generator<any, any, any> {
    let initialResult: any = null;
    const defaultUseCache = yield* isUseCacheEnabled();
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.PARTNER, payload.partnerId);

    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (defaultUseCache && initialResult) {
        yield put(getPartnerSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${partnerUrl}/${payload.partnerId}`, httpRequest.GET, null, 0, 0);
            const { data } = response.data;
            yield put(getPartnerSuccess(data));
            yield put(
                setCache({
                    key: payload.partnerId,
                    type: CACHE_TYPE.HOST,
                    value: data,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getPartnerFail(error));
        }
    }
}

function* getAllPartners({ payload }: { payload: IGetAllPartners }): Generator<any, any, any> {
    let query = '?';
    if (payload.params) query += payload.params;

    const key = payload.params ?? 'all';
    const defaultUseCache = yield* isUseCacheEnabled();
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.PARTNER, key);

    let initialResult: any = null;
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (initialResult && defaultUseCache) {
        yield put(getAllPartnersSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${partnerUrl}${query}`, httpRequest.GET, null, 0, 0);
            const { data } = response.data;
            yield put(getAllPartnersSuccess(data));
            yield put(
                setCache({
                    key,
                    type: CACHE_TYPE.PARTNER,
                    value: data,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getAllPartnersFail(error));
        }
    }
}

/**TODO: Move all vote related saga away from here to the voting saga */
function* initiateVote({ payload, resolve, reject }: { payload: IInitiate2FaForVote; resolve: any; reject: any }): any {
    const url = `${submissionsUrl}/${payload.submission_id}/vote`;
    try {
        const response = yield call(api, url, httpRequest.POST, { phone_number: payload.phone_number }, 0, 0);
        const { data, message } = response || {};
        const { message: succesMessage } = data;
        if (succesMessage) {
            /** Here the user received the messag to verifyt their phone */
            yield put(initaiet2FAForVoteSuccess(data));
            yield put(
                setInAppNotification({
                    message: succesMessage,
                    title: succesMessage,
                }),
            );
            resolve(succesMessage);
            yield all([
                put(
                    setVotingFlow({
                        submissions: [],
                        showVotingModal: false,
                    }),
                ),
                put(setVoting2Fa(false)),
            ]);
        } else {
            /** Here they ae already verified and the vote goes through successfully */
            yield put(
                setInAppNotification({
                    message: message,
                    title: message,
                }),
            );
            yield put(castVoteSuccess(response.data.data));
            yield put(
                destroyOneCache({
                    cacheType: CACHE_TYPE.USER_VOTES,
                }),
            );
            yield all([
                put(
                    setVotingFlow({
                        submissions: [],
                        showVotingModal: false,
                    }),
                ),
                put(setVoting2Fa(false)),
            ]);
            resolve(response.data.data);
        }
    } catch (error: any) {
        SentryCapture(error, 'error');
        // Check for other error codes here as well
        if (error && error.data && error.data.message) {
            const payload: IErrorType = {
                data: {
                    message: error.data.message,
                    status: 'failed',
                },
                status: 403,
                statusText: error.data.message,
            };
            yield put(
                setInAppNotification({
                    message: error.data.message,
                    title: error.data.message,
                }),
            );
            yield put(initaiet2FAForVoteFail(payload));
        }
        yield all([
            put(
                setVotingFlow({
                    submissions: [],
                    showVotingModal: false,
                }),
            ),
            put(setVoting2Fa(false)),
        ]);
        reject(error);
    }
}

function* castVote({
    payload,
    resolve,
    reject,
}: {
    payload: ICastVote;
    resolve: () => Promise<void>;
    reject: () => Promise<void>;
}): any {
    const url = `${submissionsUrl}/${payload.submission_id}/vote/verify`;
    try {
        const response = yield call(api, url, httpRequest.POST, { ...payload }, 0, 0);
        const { data } = response;
        const { message } = data;
        yield put(castVoteSuccess(data));
        yield put(
            setInAppNotification({
                message: message,
                title: message,
            }),
        );
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.USER_VOTES,
            }),
        );

        yield all([
            put(
                setVotingFlow({
                    submissions: [],
                    showVotingModal: false,
                }),
            ),
            put(setVoting2Fa(false)),
        ]);
        if (resolve) resolve();
    } catch (error: any) {
        if (error.data && error.data.message && error.data.message.startsWith('The submission voter')) {
            yield put(
                setInAppNotification({
                    message: 'Vote Already Cast',
                    title: 'Vote Already Cast',
                }),
            );
        } else {
            yield call(globalErrorHandler, error);
            SentryCapture(error, 'error');
        }
        yield put(castVoteFail(error));
        if (reject) reject();
    }
}

function* getRecommendations(): any {
    try {
        const response = yield call(api, getRecommendationUrl, httpRequest.GET, {}, 2, 2000, false);
        const { data }: { data: IContest[] } = response.data;
        yield put(getRecommendationSuccess(data));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(getRecommendationFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* createBookmark({ payload }: { payload: ICreateBookmark }): any {
    try {
        const response = yield call(api, saveCollectionUrl, httpRequest.POST, payload, 1, 2000);
        const { data } = response.data;
        yield put(createBookmarkSuccess(data));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.BOOKMARK,
            }),
        );
        yield call(showToastMessage, 'Bookmark Sucessful', 'success');
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(createBookmarkFail({ ...error, documentId: payload.details.model, additionalPayload: payload }));
        yield call(globalErrorHandler, error);
    }
}

function* deleteBookmark({ payload }: { payload: IGenericDocumentModifier }): any {
    try {
        yield call(api, `${saveCollectionUrl}/${payload.documentId}`, httpRequest.DELETE, payload, 1, 2000);
        yield put(deleteBookmarkSuccess(payload));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.BOOKMARK,
            }),
        );
        yield call(showToastMessage, 'Bookmark Removed Successfully', 'info');
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(deleteBookmarkFail({ ...error, documentId: payload.documentId, additionalPayload: payload }));
        yield call(globalErrorHandler, error);
    }
}

function* getBookmarks({
    payload,
    resolve,
    reject,
}: {
    payload: IGetSavedCollections;
    resolve: (data: IGetAllResponse<IBookmark[]>) => void;
    reject: (error: any) => void;
}): any {
    const params = new URLSearchParams();
    if (payload.type) params.append('type', String(payload.type));
    if (payload.page) params.append('page', String(payload.page));
    if (payload.limit) params.append('limit', String(payload.limit));
    const defaultUseCache = yield* isUseCacheEnabled();
    const defaultCacheDuration = yield* getCacheDuration();
    let initialResult: any = null;
    const cache: CacheValue = yield* getCacheByType(CACHE_TYPE.BOOKMARK);
    if (cache && cache.key) {
        initialResult = cache.value;
    }
    if (
        !!initialResult &&
        defaultUseCache &&
        ((Date.now() - Number(cache.key)) as unknown as number) < defaultCacheDuration
    ) {
        yield put(getBookmarkSuccess(initialResult));
        if (resolve) {
            resolve(
                //@ts-ignore
                {
                    currentPage: initialResult.currentPage,
                    data: { data: initialResult.data },
                    pageSize: initialResult.pageSize,
                    status: initialResult.status,
                    totalCount: initialResult.totalCount,
                    totalPages: initialResult.totalPages,
                },
            );
        }
    } else {
        try {
            const response = yield call(api, getSavedCollectionUrl, httpRequest.GET, null, 0, 0);
            const { data } = response.data;
            yield put(getBookmarkSuccess(data));
            yield put(
                setCache({
                    key: Date.now(),
                    type: CACHE_TYPE.BOOKMARK,
                    value: data,
                    isUnique: true,
                }),
            );
            if (resolve) {
                resolve(
                    //@ts-ignore
                    {
                        currentPage: response.currentPage,
                        data: { data: response.data },
                        pageSize: response.pageSize,
                        status: response.status,
                        totalCount: response.totalCount,
                        totalPages: response.totalPages,
                    },
                );
            }
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getBookmarkFail(error));
            if (reject) {
                reject(error);
            }
        }
    }
}

function* getMySubmissions({
    payload,
    resolve,
    reject,
}: {
    payload: IGetSubmissions;
    resolve: (data: IGetAllResponse<ISubmission[]>) => void;
    reject: (error: any) => void;
}): any {
    const params = new URLSearchParams();
    if (payload.phase) params.append('phase', String(payload.phase));
    if (payload.page) params.append('page', String(payload.page));
    if (payload.limit) params.append('limit', String(payload.limit));
    const defaultUseCache = yield* isUseCacheEnabled();
    const defaultCacheDuration = yield* getCacheDuration();
    let initialResult: any = null;
    const cache: NotUniqueCacheValue = yield* getCacheByType(CACHE_TYPE.USER_SUBMISSIONS);
    if (cache && cache.key) {
        initialResult = cache.value;
    }
    if (
        !!initialResult &&
        defaultUseCache &&
        ((Date.now() - Number(cache.key)) as unknown as number) < defaultCacheDuration
    ) {
        yield put(getMySubmissionsSuccess(initialResult));
        if (resolve) {
            resolve(
                //@ts-ignore
                {
                    currentPage: initialResult.currentPage,
                    data: { data: initialResult.data },
                    pageSize: initialResult.pageSize,
                    status: initialResult.status,
                    totalCount: initialResult.totalCount,
                    totalPages: initialResult.totalPages,
                },
            );
        }
    } else {
        try {
            const response = yield call(api, getMySubmissionsUrl, httpRequest.GET, {}, 2, 2000, false);
            const { data }: { data: ISubmission[] } = response;
            yield put(getMySubmissionsSuccess(data));
            yield setCache({
                key: Date.now(),
                type: CACHE_TYPE.USER_SUBMISSIONS,
                value: data,
                isUnique: true,
            });
            if (resolve) {
                resolve(
                    //@ts-ignore
                    {
                        currentPage: response.currentPage,
                        data: { data: response.data },
                        pageSize: response.pageSize,
                        status: response.status,
                        totalCount: response.totalCount,
                        totalPages: response.totalPages,
                    },
                );
            }
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getMySubmissionsFail(error));
            if (reject) {
                reject(error);
            }
        }
    }
}

function* submitProject({ payload, resolve, reject }: { payload: ISubmitProject; resolve: any; reject: any }): any {
    try {
        const state: RootState = yield select();
        const { contest }: { contest: IContestInitialState } = state;
        const { selectedCategoryForSubmission } = contest;
        const payloadClone: ISubmitProject = {
            ...payload,
            category: payload.category ? payload.category : selectedCategoryForSubmission,
        };
        const response = yield call(api, submissionsUrl, httpRequest.POST, payloadClone, 0, 0, false);
        const { data }: { data: ISubmission } = response.data;
        if (resolve) {
            resolve(data);
        }
        yield put(submitProjectSuccess(data));
        yield call(showToastMessage, 'Submission Successful', 'success');
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_SUBMISSIONS }));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_PROJECTS }));
        if (payload.isHostSubmission) {
            yield put(destroyOneCache({ cacheType: CACHE_TYPE.UNSUBMITTED_PROJECTS }));
        }
        yield put(refreshUserDashboard());
        yield put(setCategoryForSubmission(undefined));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        if (reject) {
            reject(error);
        }
        yield put(submitProjectFail(error));
        yield put(setCategoryForSubmission(undefined));
    }
}

function* rescindSubmission({ payload }: { payload: ISubmission }): any {
    try {
        yield call(api, `${submissionsUrl}/${payload._id}`, httpRequest.DELETE, payload, 2, 2000, false);
        yield put(rescindSubmissionSuccess(payload));
        yield call(showToastMessage, 'Submission Withdrawn', 'success');
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_SUBMISSIONS }));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_PROJECTS }));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(rescindSubmissionFail(error));
    }
}

function* updateSubmission({
    payload,
    resolve,
    reject,
}: {
    payload: IUpdateSubmission;
    resolve: (data: ISubmission) => Promise<void>;
    reject: (reason: any) => Promise<void>;
}): any {
    try {
        const { submissionId, submission_picture, testimonial_video, ...updateData } = payload;
        let uploadedImagePath;

        // Handle file upload if submission_picture is a File
        if (submission_picture instanceof File) {
            uploadedImagePath = yield call(uploadFilesSaga as any, {
                payload: {
                    collection: 'submissions',
                    directory: 'awards',
                    path: 'image',
                    files: [submission_picture],
                    id: submissionId,
                },
            });

            // Update the submission with the uploaded file path
            if (uploadedImagePath && uploadedImagePath.length > 0) {
                updateData.submission_picture = uploadedImagePath[0];
            }
        } else if (submission_picture) {
            // If it's already a string path, use it directly
            updateData.submission_picture = submission_picture;
        }

        // Handle testimonial_video as project ID
        if (testimonial_video) {
            // testimonial_video is now a project ID, not a file
            updateData.testimonial_video = testimonial_video;
        }

        const response = yield call(
            api,
            `${submissionsUrl}/${submissionId}`,
            httpRequest.PATCH,
            updateData,
            2,
            2000,
            false,
        );
        const { data } = response.data;
        yield put(updateSubmissionSuccess(data));
        if (resolve) resolve(data);
        yield call(showToastMessage, 'Submission Updated Successfully', 'success');
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_SUBMISSIONS }));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(updateSubmissionFail(error));
        if (reject) reject(error);
        yield call(showToastMessage, 'Failed to update submission', 'error');
    }
}

function* getContest({ payload }: { payload: IGetContestPayload }): any {
    const defaultUseCache = yield* isUseCacheEnabled();
    const selectedUrl = payload.isEvent ? getContestWithContestIdUrl : getContestUrl;
    let initialResult: any = null;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.CONTEST, payload.contestId);
    if (cache && cache.key) {
        initialResult = cache.value;
    }
    if (initialResult && defaultUseCache) {
        yield put(getContestSuccess({ data: initialResult }));
    } else {
        try {
            const response = yield call(
                api,
                `${selectedUrl}/${payload.contestId}${payload.params ? payload.params : ''}`,
                httpRequest.GET,
                null,
                2,
                1000,
            );
            const { data } = response.data || {};
            const parsedResponse = data;
            yield put(getContestSuccess({ data: data }));

            if (payload.params) {
                /** If there is payload then clear search suggestion. Currently the payload being passed is ?search=true
                 * This should reset our search suggestion to get the most recent search result when the search box is tapped
                 * again
                 *
                 * TODO: Check for that params is specifically for search
                 */
                yield put(destroyOneCache({ cacheType: CACHE_TYPE.SEARCH_SUGGESTION }));
            }
            yield put(
                setCache({
                    key: payload.contestId,
                    value: parsedResponse,
                    type: CACHE_TYPE.CONTEST,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield call(globalErrorHandler, error);
            yield put(getContestFail(error));
        }
    }
}
/** Mind the s in thie spelling as in GetContests with an S
 * This will also return similar contests and recommendations
 */
function* getAllContests({ payload }: { payload: IGetContests }): any {
    const defaultUseCache = yield* isUseCacheEnabled();
    let initialResult: any = null;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(
        CACHE_TYPE.CONTEST,
        (payload.params as string) ?? Date.now(),
    );
    if (cache && cache.key) {
        initialResult = cache.value;
    }
    if (initialResult && defaultUseCache) {
        yield put(getContestsSuccess({ data: initialResult, isFilitered: !!payload.params }));
    } else {
        try {
            const response = yield call(api, `${getContestUrl}${payload.params}`, httpRequest.GET, null, 2, 1000);
            const { data } = response.data;
            yield put(getContestsSuccess({ data: data, isFilitered: !!payload.params }));
            yield put(
                setCache({
                    key: payload.params ?? Date.now(),
                    value: data,
                    type: CACHE_TYPE.CONTEST,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getContestsFail(error));
        }
    }
}

/**
 * Saga to fetch contest submissions
 * @param param0
 */
function* getContestSubmissionsData({
    payload,
    resolve,
    reject,
}: {
    payload: IGetContestSubmissions;
    resolve: any;
    reject: any;
}): Generator<any, any, any> {
    try {
        const { contestId, page = 1, limit = 9, searchTerm, sort, order } = payload;

        // Build the query parameters
        const queryParams = new URLSearchParams();
        if (page) queryParams.append('page', String(page));
        if (limit) queryParams.append('limit', String(limit));
        if (searchTerm) queryParams.append('searchTerm', searchTerm);
        if (sort) queryParams.append('sort', sort);
        if (order) queryParams.append('order', order);

        // Construct the URL
        const url = `${submissionsUrl}/${contestId}/entries?${queryParams.toString()}`;

        // Call the API
        const response = yield call(api, url, httpRequest.GET, null, 2, 1000);

        yield put(getContestSubmissionsSuccess(response));
        if (resolve) resolve(response);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(getContestSubmissionsFail(error));
        yield call(globalErrorHandler, error);
        if (reject) reject(error);
    }
}

interface ContestManager extends Action {
    payload: IGetManageCampiagn;
    resolve?: (response: any) => Promise<void>;
    reject?: (reason: any) => Promise<void>;
}

function* getContestManageSaga({ payload, resolve, reject }: ContestManager): Generator<any, void, any> {
    try {
        const { contestId, ...rest } = payload;

        const queryParams = Object.entries(rest)
            .filter(([, value]) => value !== undefined && value !== null && value !== '')
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`)
            .join('&');

        const request = `${getContestUrl}/${contestId}/manage${queryParams ? `?${queryParams}` : ''}`;

        const response = yield call(api, request, 'GET', null);
        const { data } = response;
        yield put(getContestManageSuccess(data));
        if (resolve) resolve(response);
    } catch (error: any) {
        yield put(getContestManageFail(error));
        if (reject) reject(error);
    }
}
// Video Management Sagas
function* getPreselectionSubmissionsSaga({ payload }: { payload: IGetPreselectionSubmissions }): any {
    try {
        const {
            contestId,
            page = 1,
            limit = 10,
            category,
            searchTerm,
            selection_state,
            selection_email_sent,
            pre_selection_completed,
            sort = 'total_average',
            order = 'desc',
        } = payload;

        const queryParams = new URLSearchParams();
        queryParams.append('page', page.toString());
        queryParams.append('limit', limit.toString());
        queryParams.append('sort', sort);
        queryParams.append('order', order);

        if (category && category.length > 0) {
            category.forEach(cat => queryParams.append('category', cat));
        }

        if (searchTerm) {
            queryParams.append('searchTerm', searchTerm);
        }

        if (selection_state) {
            queryParams.append('selection_state', selection_state);
        }

        if (selection_email_sent !== undefined && selection_email_sent !== '') {
            queryParams.append('selection_email_sent', selection_email_sent.toString());
        }

        if (pre_selection_completed !== undefined && pre_selection_completed !== '') {
            queryParams.append('pre_selection_completed', pre_selection_completed.toString());
        }

        const url = `${submissionsUrl}/preselection/${contestId}?${queryParams.toString()}`;
        const response = yield call(api, url, httpRequest.GET, null);

        yield put(getPreselectionSubmissionsSuccess(response));
    } catch (error: any) {
        yield put(getPreselectionSubmissionsFail(error));
    }
}

function* preselectSubmissionsSaga({ payload }: { payload: IPreselectSubmissions }): any {
    try {
        const { contestId, submissionIds, selection_state } = payload;

        const url = `${submissionsUrl}/preselect`;
        const response = yield call(api, url, httpRequest.POST, {
            contestId,
            submissionIds,
            selection_state,
        });

        yield put(preselectSubmissionsSuccess(response));

        // Refresh the submissions list to get updated selection states
        // yield put(getPreselectionSubmissions({ contestId }));

        // Show success message
        yield put(
            setInAppNotification({
                title: 'Success',
                message: `Submissions ${selection_state === 'selected' ? 'selected' : 'deselected'} successfully`,
            }),
        );
    } catch (error: any) {
        yield put(preselectSubmissionsFail(error));

        // Show error notification
        yield put(
            setInAppNotification({
                title: 'Error',
                message: 'Failed to update submission selection',
            }),
        );
    }
}

function* sendSelectionEmailSaga({ payload }: { payload: ISendSelectionEmail }): any {
    try {
        const { contestId, submissionIds, subject, message } = payload;

        const requestBody = {
            submissionIds,
            subject: subject || 'Contest Selection Notification',
            message: message || 'Your video has been selected for the contest.',
        };

        const url = `${submissionsUrl}/preselect/email/${contestId}`;
        const data = yield call(api, url, httpRequest.POST, requestBody);

        yield put(sendSelectionEmailSuccess(data));

        // Show success notification
        yield put(
            setInAppNotification({
                title: 'Success',
                message: `Email sent successfully for ${submissionIds.length} selected video${
                    submissionIds.length > 1 ? 's' : ''
                }`,
            }),
        );
    } catch (error: any) {
        yield put(sendSelectionEmailFail(error));
        yield call(globalErrorHandler, error);
        // Show error notification
        yield put(
            setInAppNotification({
                title: 'Error',
                message: 'Failed to send selection email',
            }),
        );
    }
}

interface TaskAction extends Action {
    payload: ICreateContestPayload;
}

interface Modifier extends Action {
    payload: IGenericDocumentModifier;
}

interface ContestFetcher extends Action {
    payload: IGetUserContest;
}

interface HostCreator extends Action {
    payload: ICreateHost;
}

interface PartnerCreator extends Action {
    payload: ICreatePartner;
}

interface HostGetter extends Action {
    payload: IGetHost;
}

interface AllHostGetter extends Action {
    payload: IGetAllHosts;
}

interface AllPartnerGetter extends Action {
    payload: IGetAllPartners;
}

interface PartnerGetter extends Action {
    payload: IGetPartner;
}

interface HostSearch extends Action {
    payload: ISearchPayload;
}

interface AwardCatgeory extends Action {
    payload: ICreateAwardCategory;
}

interface ContestReference extends Action {
    payload: string[];
}

interface UnsubmittedProjects extends Action {
    payload: IGetUnsubmittedProjects;
}
interface GetS3Images extends Action {
    payload: IGetS3ImagesResponse;
}

interface IDeleter extends Action {
    payload: IGenericDocumentModifier;
}

function* deleteAwardCategoryWatcher() {
    yield takeLatest<IDeleter>(types.DELETE_AWARD_CATEGORY, deleteAwardCategory);
}

function* getContestReferencesWatcher() {
    yield takeLatest<ContestReference>(types.GET_CONTEST_REFERENCES, getContestReferences);
}

function* getRecommendationsWatcher() {
    yield takeLatest(types.GET_RECOMMENDATION, getRecommendations);
}

function* getBookmarksWatcher() {
    yield takeLatest<any>(types.GET_BOOKMARK, getBookmarks);
}

function* submitProjectWatcher() {
    yield takeLatest<any>(types.SUBMIT_PROJECT, submitProject);
}

function* getMySubmisisonsWatcher() {
    yield takeLatest<any>(types.GET_MY_SUBMISSIONS, getMySubmissions);
}

function* getContestWatcher() {
    yield takeLatest<any>(types.GET_CONTEST, getContest);
}

function* getContestsWatcher() {
    yield takeLatest<any>(types.GET_CONTESTS, getAllContests);
}

function* rescindSubmissionWatcher() {
    yield takeLatest<any>(types.RESCIND_SUBMISSION, rescindSubmission);
}

function* updateSubmissionWatcher() {
    yield takeLatest<any>(types.UPDATE_SUBMISSION, updateSubmission);
}

function* initiateVoteWatcher() {
    yield takeLatest<any>(types.INITIATE_2FA_FOR_VOTE, initiateVote);
}

function* castVoteWatcher() {
    yield takeLatest<any>(types.VOTE_FOR_SUBMISSION, castVote);
}

function* createBookmarkWatcher() {
    yield takeLatest<any>(types.CREATE_BOOKMARK, createBookmark);
}
function* deleteBookmarksWatcher() {
    yield takeLatest<any>(types.DELETE_BOOKMARK, deleteBookmark);
}

function* createContestWatcher() {
    yield takeLatest<TaskAction>(types.CREATE_CONTEST, createContest);
}

function* updateContestWatcher() {
    yield takeLatest<Modifier>(types.UPDATE_CONTEST, updateContest);
}

function* deleteContestWatcher() {
    yield takeLatest<Modifier>(types.DELETE_CONTEST, deleteContest);
}

function* createHostWatcher() {
    yield takeLatest<HostCreator>(types.CREATE_HOST, createHost);
}

function* updateHostWatcher() {
    yield takeLatest<Modifier>(types.UPDATE_HOST, updateHost);
}

function* deleteHostWatcher() {
    yield takeLatest<Modifier>(types.DELETE_HOST, deleteHost);
}

function* getHostWatcher() {
    yield takeLatest<HostGetter>(types.GET_HOST, getHost);
}

function* geAllHostWatcher() {
    yield takeLatest<AllHostGetter>(types.GET_ALL_HOSTS, getAllHost);
}

function* createPartnerWather() {
    yield takeLatest<PartnerCreator>(types.CREATE_PARTNER, createPartner);
}

function* updatePartnerWather() {
    yield takeLatest<Modifier>(types.UPDATE_PARTNER, updatePartner);
}

function* delePartnerWather() {
    yield takeLatest<Modifier>(types.DELETE_PARTNER, delePartner);
}

function* getPartnerWather() {
    yield takeLatest<PartnerGetter>(types.GET_PARTNER, getPartner);
}

function* getAllPartnersWather() {
    yield takeLatest<AllPartnerGetter>(types.GET_ALL_PARTNERS, getAllPartners);
}

function* publishContestWatcher() {
    yield takeLatest<Modifier>(types.PUBLISH_CONTEST, publishContest);
}
function* unPublishContestWatcher() {
    yield takeLatest<Modifier>(types.UNPUBLISH_CONTEST, unPublishContest);
}

function* getUserContestWatcher() {
    yield takeLatest<ContestFetcher>(types.GET_USER_CONTEST, getUserContest);
}

function* getUserContestsWatcher() {
    yield takeLatest<any>(types.GET_USER_CONTESTS, getUserContests);
}
function* searchHostWatcher() {
    yield takeLatest<HostSearch>(types.SEARCH_HOST, searchHost);
}

function* searchPartnerWatcher() {
    yield takeLatest<HostSearch>(types.SEARCH_PARTNER, searchPartner);
}

function* createAwardCategoryWatcher() {
    yield takeLatest<AwardCatgeory>(types.CREATE_AWARD_CATEGORY, createAwardCategory);
}

function* getAssignedCodesWatcher() {
    yield takeLatest<any>(types.GET_REDEEMABLE_CODE, getAssignedCodes);
}

function* assigRedeemableCodeWatcher() {
    yield takeLatest<any>(types.ASSIGN_REDEEMABLE_CODE, assignCodes);
}

function* downloadAssetWatcher() {
    yield takeLatest<any>(types.DOWNLOAD_ASSET, downloadAsset);
}

function* getAwardCategoriesWatcher() {
    yield takeLatest<any>(types.GET_AWARD_CATEGORIES_FOR_CONTEST, getAwardCategories);
}

function* getAwardPrizesWatcher() {
    yield takeLatest<any>(types.GET_AWARDED_PRIZES_FOR_CONTEST, getAwardPrizes);
}

function* awardPrizeWatcher() {
    yield takeLatest<any>(types.AWARD_PRIZE, awardMultiplePrizez);
}

function* sendConclusionEmailWatcher() {
    yield takeLatest<any>(types.SEND_WINNERS_EMAIL, sendConclusionEmail);
}

function* sendContestEmailWatcher() {
    yield takeLatest<any>(types.SEND_CONTEST_EMAIL, sendContestEmailSaga);
}
function* getContestScoreBoardWatcher() {
    yield takeLatest<any>(types.GET_ALL_SUBMISSIONS, getContestScoreBoard);
}

function* createScoreCategoryWatcher() {
    yield takeLatest<any>(types.CREATE_SCORE_CATEGORY, createScoreCategory);
}

function* getUnsubmittedProjectsWatcher() {
    yield takeLatest<UnsubmittedProjects>(types.GET_USERS_UNSUBMITTED_PROJECTS, getUnsubmittedProjects);
}

function* getS3ImagesWatcher() {
    yield takeLatest<GetS3Images>(types.GET_S3_IMAGES, getS3ImagesSaga);
}

function* getContestSubmissionsDataWatcher() {
    yield takeLatest<any>(types.GET_CONTEST_SUBMISSIONS, getContestSubmissionsData);
}

function* getContestManageWatcher() {
    yield takeLatest<any>(types.GET_MANAGE_CAMPAIGN, getContestManageSaga);
}

function* updateCampaignAwardWatcher() {
    yield takeLatest<any>(types.UPDATE_CAMPAIGN_AWARDS, updateCampaignAwardCategories);
}

function* updateAwardCategoryWatcher() {
    yield takeLatest<any>(types.UPDATE_AWARD_CATEGORY, updateAwardCategory);
}

function* verifyProjectWatcher() {
    yield takeLatest<any>(types.VERIFY_PROJECT_SUBMISSION, verifyProject);
}
// Video Management Watchers
function* getPreselectionSubmissionsWatcher() {
    yield takeLatest<any>(types.GET_PRESELECTION_SUBMISSIONS, getPreselectionSubmissionsSaga);
}

function* preselectSubmissionsWatcher() {
    yield takeLatest<any>(types.PRESELECT_SUBMISSIONS, preselectSubmissionsSaga);
}

function* sendSelectionEmailWatcher() {
    yield takeLatest<any>(types.SEND_SELECTION_EMAIL, sendSelectionEmailSaga);
}

export default function* contestSaga() {
    yield all([
        assigRedeemableCodeWatcher(),
        awardPrizeWatcher(),
        castVoteWatcher(),
        createAwardCategoryWatcher(),
        createBookmarkWatcher(),
        createContestWatcher(),
        createHostWatcher(),
        createPartnerWather(),
        createScoreCategoryWatcher(),
        delePartnerWather(),
        deleteAwardCategoryWatcher(),
        deleteBookmarksWatcher(),
        deleteContestWatcher(),
        deleteHostWatcher(),
        downloadAssetWatcher(),
        geAllHostWatcher(),
        updateCampaignAwardWatcher(),
        updateAwardCategoryWatcher(),
        getAllPartnersWather(),
        getAssignedCodesWatcher(),
        getAwardCategoriesWatcher(),
        getAwardPrizesWatcher(),
        getBookmarksWatcher(),
        getContestReferencesWatcher(),
        getContestScoreBoardWatcher(),
        getContestsWatcher(),
        getContestWatcher(),
        getHostWatcher(),
        getMySubmisisonsWatcher(),
        getPartnerWather(),
        getPreselectionSubmissionsWatcher(),
        getRecommendationsWatcher(),
        getS3ImagesWatcher(),
        getUnsubmittedProjectsWatcher(),
        getUserContestsWatcher(),
        getUserContestWatcher(),
        initiateVoteWatcher(),
        publishContestWatcher(),
        rescindSubmissionWatcher(),
        updateSubmissionWatcher(),
        searchHostWatcher(),
        searchPartnerWatcher(),
        sendConclusionEmailWatcher(),
        sendContestEmailWatcher(),
        sendSelectionEmailWatcher(),
        submitProjectWatcher(),
        unPublishContestWatcher(),
        updateContestWatcher(),
        updateHostWatcher(),
        updatePartnerWather(),
        getContestSubmissionsDataWatcher(),
        getContestManageWatcher(),
        verifyProjectWatcher(),
        preselectSubmissionsWatcher(),
    ]);
}
